import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Cropper from 'react-easy-crop';
import getCroppedPhoto from './cropImage';
import { FitHeight, FitWidth, Reset, CropImg, closeImg } from 'assets';
import { useSelector } from 'react-redux';
import styles from './style.module.scss';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import classNames from 'classnames';

const CropThumbnail = ({
    show,
    uploadedPhotoUrl,
    setUploadedPhotoURL,
    setOpenCrop,
    setSelectedPhotos,
    setProgresses,
    setPhoto,
    cropShape,
    aspect,
    setFile,
    UploadedFile,
    handleClose,
    setSelectedImage,
    backdrop,
    setArray,
    status

}) => {
    const [wait, setWait] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [isInitialCrop, setIsInitialCrop] = useState(true);
    const [initialCrop, setInitialCrop] = useState({ x: 0, y: 0 });
    const [cropSize, setCropSize] = useState({ width: 0, height: 0 });
    const [mediaSize, setMediaSize] = useState({
        width: 0,
        height: 0,
        naturalWidth: 0,
        naturalHeight: 0
    });
    const zoomSliderRef = useRef(null);
    const rotationSliderRef = useRef(null);
    const cropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const cropPhoto = async () => {
        const croppedPhoto = await getCroppedPhoto(uploadedPhotoUrl, croppedAreaPixels, rotation);
        if (croppedPhoto) {
            if ((cropShape === 'round' && aspect === 1) || (cropShape === 'rect' && aspect === 16 / 4) || (cropShape === 'rect' && aspect === 1)) {
                setUploadedPhotoURL(croppedPhoto.url);
                setSelectedImage(croppedPhoto.url);

                // Fetch the file using the URL
                const response = await fetch(croppedPhoto.url);
                const blob = await response.blob();

                // Create a File object from the blob
                const file = new File([blob], croppedPhoto.file.name, { type: blob.type });

                setFile(file);
                if(status==='uploadArray'){
                    setArray(file)
                }
                setWait(false);
                setZoom(1);
                setRotation(0);
                handleClose();
            }
        }
    };

    const resetAll = () => {
        handleClose();
    };

    useEffect(() => {
        if (zoomSliderRef.current) {
            const zoomProgress = ((zoom - 1) / 2) * 100;
            zoomSliderRef.current.style.background = `linear-gradient(to right, #2196f3 ${zoomProgress}%, #ddd ${zoomProgress}%)`;
        }

        if (rotationSliderRef.current) {
            const rotationProgress = (rotation / 360) * 100;
            rotationSliderRef.current.style.background = `linear-gradient(to right, #2196f3 ${rotationProgress}%, #ddd ${rotationProgress}%)`;
        }
    }, [zoom, rotation]);

    return (
        <Modal show={show} onHide={resetAll} backdrop={backdrop} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body className={` ${styles.ThumbnailContainer}`}>
                <div className={styles.CropperContainer}>
                    <img src={closeImg} alt="close-icon" className={styles.closeIcon} onClick={resetAll} />
                    <Cropper
                        image={uploadedPhotoUrl}
                        crop={crop}
                        zoom={zoom}
                        rotation={rotation}
                        minZoom={1}
                        maxZoom={3}
                        aspect={aspect}
                        objectFit="contain"
                        cropShape={cropShape}
                        restrictPosition={true}
                        zoomWithScroll={false}
                        onZoomChange={setZoom}
                        setMediaSize={setMediaSize}
                        setCropSize={setCropSize}
                        onRotationChange={(rotation) => {
                            if (rotation > 0 || rotation === 0) {
                                setRotation(rotation);
                            }
                        }}
                        onCropChange={(crop) => {
                            if (isInitialCrop) {
                                setCrop(crop);
                                setInitialCrop(crop);
                                setIsInitialCrop(false);
                            } else {
                                setCrop(crop);
                            }
                        }}
                        onCropComplete={cropComplete}
                    />
                </div>
                <div className={styles.ControlsContainer}>
                    <div className={styles.ZoomControl}>
                        <div className={styles.ZoomLabel}>Zoom: {zoomPercent(zoom)}</div>
                        <input type="range" min="1" max="3" step="0.01" value={zoom} onChange={(e) => setZoom(e.target.value)} className={styles.customSlider} ref={zoomSliderRef} />
                    </div>
                    <div className={styles.RotationControl}>
                        <div className={styles.RotationLabel}>Rotation: {rotation + '°'}</div>
                        <input type="range" min="0" max="360" value={rotation} onChange={(e) => setRotation(e.target.value)} className={styles.customSlider} ref={rotationSliderRef} />
                    </div>
                    <div className={styles.ButtonContainer}>
                        <CustomButton
                            Icon={FitHeight}
                            IconStyle={classNames(styles.FilterIcon)}
                            containerStyle={classNames(styles.FilterButton)}
                            text="Fit To Height"
                            submitHandle={() => {
                                setZoom(1);
                                setRotation(0);
                                setCrop(initialCrop);
                                setZoom(cropSize.height / mediaSize.height);
                            }}
                        />
                        <CustomButton
                            Icon={FitWidth}
                            IconStyle={classNames(styles.FilterIcon)}
                            containerStyle={classNames(styles.FilterButton)}
                            text="Fit To Width"
                            submitHandle={() => {
                                setZoom(1);
                                setRotation(0);
                                setZoom(cropSize.width / mediaSize.width);
                                setCrop(initialCrop);
                            }}
                        />
                    </div>
                    <div className={styles.ButtonContainer}>
                        <CustomButton
                            Icon={Reset}
                            IconStyle={classNames(styles.FilterIcon)}
                            containerStyle={classNames(styles.FilterButton)}
                            text="Reset"
                            submitHandle={() => {
                                setZoom(1);
                                setRotation(0);
                                setCrop(initialCrop);
                            }}
                        />
                        <CustomButton
                            Icon={CropImg}
                            IconStyle={classNames(styles.FilterCropIcon)}
                            containerStyle={classNames(styles.FilterButton)}
                            text="Crop"
                            submitHandle={() => {
                                setWait(true);
                                cropPhoto();
                            }}
                        />
                    </div>
                </div>
                {wait && (
                    <div className={styles.box__circularprogress}>
                        <div className={styles.circular__progress}>Loading...</div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default CropThumbnail;

const zoomPercent = (value) => {
    return `${Math.round(value * 100)}%`;
};
